import type { CssGeneratorContext } from '../css-generator.model';

export const styles = ({ dt }: CssGeneratorContext) => `.inspection-representative-modal-detail .app-value-section {
  gap: ${dt('inspectionRepresentativeModal.detail.gap')};
}

.inspection-representative-modal-detail .app-value-section p.title {
  color: ${dt('inspectionRepresentativeModal.detail.label.color')};
  font-size: ${dt('inspectionRepresentativeModal.detail.label.fontSize')};
  line-height: ${dt('inspectionRepresentativeModal.detail.label.lineHeight')};
  font-weight: ${dt('inspectionRepresentativeModal.detail.label.fontWeight')};
}

.inspection-representative-modal-detail .app-value-section p.value {
  color: ${dt('inspectionRepresentativeModal.detail.value.color')};
  font-size: ${dt('inspectionRepresentativeModal.detail.value.fontSize')};
  line-height: ${dt('inspectionRepresentativeModal.detail.value.lineHeight')};
  font-weight: ${dt('inspectionRepresentativeModal.detail.value.fontWeight')};
}

.inspection-representative-modal-select.p-select,
.inspection-representative-modal-select.p-select:not(.p-disabled):hover,
.inspection-representative-modal-select.p-select:not(.p-disabled).p-focus {
  border-color: ${dt('inspectionRepresentativeModal.select.borderColor')} !important;
}

.inspection-representative-modal-option-role {
  color: ${dt('inspectionRepresentativeModal.option.roleColor')};
}

.inspection-representative-modal-default-badge {
  color: ${dt('inspectionRepresentativeModal.defaultBadge.color')} !important;
  font-size: ${dt('inspectionRepresentativeModal.defaultBadge.fontSize')};
  font-weight: ${dt('inspectionRepresentativeModal.defaultBadge.fontWeight')};
  line-height: ${dt('inspectionRepresentativeModal.defaultBadge.lineHeight')};
  min-width: ${dt('inspectionRepresentativeModal.defaultBadge.minWidth')};
  text-align: right;
}`;
